// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f565bfac","732":"19baa21f"}[chunkId] + ".chunk.js";
};